<script>
import { ColorPicker } from 'element-ui';

export default {
  extends: ColorPicker,
  watch: {
    showPicker: {
      handler(newValue) {
        if (newValue === false) {
          this.$emit('input', this.color.value);
          this.$emit('change', this.color.value);
        }
      },
    },
  },
};
</script>
